import React from 'react';
import { useLocation } from 'react-router-dom';
import AdminAppBar from '../Component/Admin/AdminAppBar';
import AssessorAppBar from '../Component/Assessor/AssessorAppBar';
import VendorAppBar from '../Component/Vendor/VendorAppBar';
import { ClientAppBar } from '../Component/Client/ClientAppBar';
import { CorporateAppBar } from '../Component/Corporate/CorporateAppBar';

const AppBarSelector = ({ children }) => {
  const location = useLocation();
  const user = JSON.parse(sessionStorage.getItem('user'));
  const role = user ? user.type : 'client'; 
  const showAppBar = location.pathname !== '/signin' && location.pathname !== '/forgotPassword';
  let AppBarComponent;

  switch (role) {
    case 'admin':
      AppBarComponent = AdminAppBar;
      break;
    case 'assessor':
      AppBarComponent = AssessorAppBar;
      break;
      case 'corporate':
        AppBarComponent = CorporateAppBar;
        break;
    case 'vendor':
      AppBarComponent = VendorAppBar;
      break;
    case 'client':
      AppBarComponent = ClientAppBar
      break;
    default:
      AppBarComponent = ClientAppBar;
      break;
  }

  return (
    <div>
      {showAppBar && <AppBarComponent />}
      <div>{children}</div>
    </div>
  );
};

export default AppBarSelector;
